export async function autocompleteInit() {
  if (!window.matchMedia('(min-width: 768px)').matches) {
    return;
  }
  await import('simplebar');
  await import('resize-observer-polyfill').then(
    ({ default: ResizeObserver }) => {
      window.ResizeObserver = ResizeObserver;
    }
  );
  const simplebar = document.querySelectorAll('.js-simplebar');
  if (simplebar.length) {
    await import('simplebar').then(({ default: SimpleBar }) => {
      simplebar.forEach((item) => {
        new SimpleBar(item, {
          scrollbarMaxSize: 10,
        });
      });
    });
  }
}

// autocomplete on hover
export function autocompleteHoverInit() {}
